import axios from 'axios'

export const instance = axios.create({
  baseURL: '',
  headers: localStorage.getItem('token') ? {Authorization: `Bearer ${localStorage.getItem('token')}`} : undefined,
})